import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';

import Statistics from './pages/Statistics/Statistics';
import ExamDetails from './pages/exam_details/exam_details';
import './App.css';
import ExamHistory from './pages/exams_history/exams_history';
import Login from './pages/Login/Login';
import Cadastro from './pages/Cadastro/Cadastro';
import EsqueciSenha from './pages/esqueci_senha/esqueci_senha';
import Perfil from './pages/Perfil/Perfil';
import Ranking from './pages/Ranking/Ranking';
import RedefinirSenha from './pages/redefinir_senha/redefinir_senha';
import Disciplinas from './pages/disciplinas/disciplinas';
import Relatorio from './pages/relatorio/relatorio';
import LocalDeProva from './pages/LocalDeProva/LocalDeProva';
//import RelatorioTeste from './pages/relatorio_teste/relatorio_teste';

const ProtectedRoutes = ({ children }) => {
    const navigate = useNavigate();

    useEffect(() => {
        const userID = localStorage.getItem('userID');
        if (!userID) {
            navigate('/login'); 
        }
    }, [navigate]);

    return children;
};

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/cadastro" element={<Cadastro />} />
                <Route path="/esqueciasenha" element={<EsqueciSenha />} />
                <Route path="/redefinir_senha.php" element={<RedefinirSenha />} />

                {/* Captura redefinir_senha/* para outras rotas dinâmicas */}
                <Route path="/redefinir_senha/*" element={<RedefinirSenha />} />

                <Route path="/disciplinas" element={<Disciplinas />} />

                <Route path="/relatorio" element={<Relatorio />} />
                
                {/*<Route path="/relatorio-teste" element={<RelatorioTeste />} /> */}

                <Route 
                    path="/dashboard" 
                    element={
                        <ProtectedRoutes>
                            <Statistics />
                        </ProtectedRoutes>
                    } 
                />
                <Route 
                    path="/detalhes" 
                    element={
                        <ProtectedRoutes>
                            <ExamDetails />
                        </ProtectedRoutes>
                    } 
                />
                <Route 
                    path="/historico" 
                    element={
                        <ProtectedRoutes>
                            <ExamHistory />
                        </ProtectedRoutes>
                    } 
                />

                <Route 
                    path="/ranking" 
                    element={
                        <ProtectedRoutes>
                            <Ranking />
                        </ProtectedRoutes>
                    } 
                />

                <Route 
                    path="/local-de-prova" 
                    element={
                        <ProtectedRoutes>
                            <LocalDeProva />
                        </ProtectedRoutes>
                    } 
                />

                <Route 
                    path="/" 
                    element={
                        <ProtectedRoutes>
                            <Perfil />
                        </ProtectedRoutes>
                    } 
                />
            </Routes>
        </Router>
    );
}

export default App;
